"use strict";import e from"../src/express/scale-medium.css.js";import{Theme as m}from"../src/Theme.js";import"../src/express/core.js";m.registerThemeFragment("medium-express","scale",e);
//# sourceMappingURL=scale-medium.js.map
